import { DataSourceMode,  DataSourceExecutionEvent,  DropdownSelectionEvent,  FocusEvent,  DataDisplayEvent } from "@mcleod/components";
import { AutogenLayoutRenditionEmailProfiles } from "./autogen/AutogenLayoutRenditionEmailProfiles";
import { ClickEvent, DropdownItem } from "@mcleod/components";
import { ModelRow, ModelSearchResult, StringUtil, UserSettings } from "@mcleod/core";
import { RenditionProfiles } from "./RenditionProfiles";

export class RenditionEmailProfiles extends AutogenLayoutRenditionEmailProfiles {

    override onLoad() {
        this.SetAttTypeSngMul();
    }

    SetAttTypeSngMul()
    {
        const items: DropdownItem[] = [];
        //items.push({ caption: "tif", value: "tif" });
        //items.push({ caption: "pdf", value: "pdf" });
        items.push(new DropdownItem( "tif", "tif" ));
        items.push(new DropdownItem( "pdf", "pdf" ));
        this.textbox16.items = items;

        const items2: DropdownItem[] = [];
        //items2.push({ caption: "Single File", value: "S" });
        //items2.push({ caption: "Multiple Files", value: "M" });
        items2.push(new DropdownItem( "S", "Single File" ));
        items2.push(new DropdownItem( "M", "Multiple Files" ));
        this.textbox17.items = items2;
    }

/** This is an event handler for the onDropdownSelection event of textbox16. */
  textbox16AfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionEmailProfiles.activeRow;
    row.set( "emailp_attachtype", event.selection.displayValue );
    this.textbox16.field = event.selection.displayValue;
  }

/** This is an event handler for the onDropdownSelection event of textbox17. */
  textbox17AfterDropdownSelection(event: DropdownSelectionEvent) {
    const row = this.sourceRenditionEmailProfiles.activeRow;
    row.set( "emailp_snglmult", event.selection.displayValue.charAt(0) );
    this.textbox17.field = event.selection.displayValue;
  }
}
